(() => {
  const SCROLL_KEY = 'cslt-pagination-scroll';

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const getScrollTop = (target) => {
    let top = 0;
    let el = target;

    while (el) {
      top += el.offsetTop || 0;
      el = el.offsetParent;
    }

    return Math.max(0, top - 24);
  };

  const forceScroll = (top, behavior = 'auto') => {
    window.scrollTo({ top, left: 0, behavior });
    document.documentElement.scrollTop = top;
    document.body.scrollTop = top;
  };

  const getScrollTarget = (root) => {
    const scope = root instanceof Element ? root : document;

    return (
      scope.querySelector('#search-results-top') ||
      scope.querySelector('.search-toolbar-wrap') ||
      scope.querySelector('[data-cslt-toolbar]') ||
      scope.querySelector('.collection-products-grid') ||
      scope.querySelector('[data-gifting-grid]') ||
      scope.querySelector('.collection-shop-list-band:not([data-cslt-hidden="true"])') ||
      scope.querySelector('.template-search__header') ||
      (scope instanceof Element ? scope : null)
    );
  };

  const scrollToResults = (root = document, behavior = 'auto') => {
    const target = getScrollTarget(root);
    if (!target) return;

    const top = getScrollTop(target);
    forceScroll(top, behavior);
    requestAnimationFrame(() => forceScroll(top, behavior));
    window.setTimeout(() => forceScroll(top, behavior), 50);
    window.setTimeout(() => forceScroll(top, behavior), 150);
  };

  const markScrollIntent = () => {
    try {
      sessionStorage.setItem(SCROLL_KEY, '1');
    } catch (error) {
      /* ignore */
    }
  };

  const getPageFromUrl = (search = window.location.search) => {
    const page = parseInt(new URLSearchParams(search).get('page') || '1', 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  };

  const buildUrlWithPage = (page, { search = window.location.search, pathname = window.location.pathname } = {}) => {
    const params = new URLSearchParams(search);
    if (page <= 1) {
      params.delete('page');
    } else {
      params.set('page', String(page));
    }
    const qs = params.toString();
    return qs ? `${pathname}?${qs}` : pathname;
  };

  const syncPageToUrl = (page, { replace = false } = {}) => {
    const nextUrl = buildUrlWithPage(page);
    const currentUrl = window.location.pathname + window.location.search;
    if (nextUrl === currentUrl) return;

    const state = { csltPage: page };
    if (replace) {
      history.replaceState(state, '', nextUrl);
    } else {
      history.pushState(state, '', nextUrl);
    }
    markScrollIntent();
  };

  const seedHistoryStateFromUrl = () => {
    const page = getPageFromUrl();
    if (page <= 1) return;
    if (history.state?.csltPage === page) return;
    history.replaceState({ csltPage: page }, '', window.location.pathname + window.location.search);
  };

  const shouldScrollOnLoad = () => {
    try {
      if (sessionStorage.getItem(SCROLL_KEY) === '1') return true;
    } catch (error) {
      /* ignore */
    }

    return getPageFromUrl() > 1;
  };

  const bindPagination = () => {
    document.querySelectorAll('.cslt-pagination a[href]').forEach((link) => {
      if (link.dataset.csltScrollBound === 'true') return;
      link.dataset.csltScrollBound = 'true';
      link.addEventListener('click', markScrollIntent);
    });
  };

  const runPaginatedScroll = () => {
    const isSearch = document.querySelector('.template-search');
    const isCollection = document.querySelector('.collection-shop-list-stage:not(.gifting-shop-stage)');
    if (!isSearch && !isCollection) return;
    if (!shouldScrollOnLoad()) return;

    try {
      sessionStorage.removeItem(SCROLL_KEY);
    } catch (error) {
      /* ignore */
    }

    scrollToResults(document, 'auto');
  };

  window.CsltPagination = {
    scrollToResults,
    markScrollIntent,
    getPageFromUrl,
    buildUrlWithPage,
    syncPageToUrl,
    seedHistoryStateFromUrl,
  };

  const init = () => {
    seedHistoryStateFromUrl();
    bindPagination();
    runPaginatedScroll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', runPaginatedScroll);
  window.addEventListener('pageshow', runPaginatedScroll);
  document.addEventListener('shopify:section:load', init);
})();
